import { render, staticRenderFns } from "./tab-related-work-item.vue?vue&type=template&id=7ba8eee6&"
import script from "./tab-related-work-item.vue?vue&type=script&lang=js&"
export * from "./tab-related-work-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports